import { render, staticRenderFns } from "./amountCard.vue?vue&type=template&id=7c8ef248&"
import script from "./amountCard.vue?vue&type=script&lang=js&"
export * from "./amountCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports